(() => {
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const records = template => [...(template?.content.querySelectorAll('[data-search-record]') || [])].map(el => ({...el.dataset}));
  const safeURL = value => { try { const u = new URL(value, location.origin); return u.origin === location.origin ? u.href : '#'; } catch { return '#'; } };
  const init = root => root.querySelectorAll('[data-cosmo-search]').forEach(form => {
    if (form.dataset.searchReady) return;
    form.dataset.searchReady = 'true';
    const input = form.querySelector('input[type=search]'), list = form.querySelector('[role=listbox]');
    const clear = form.querySelector('[data-search-clear]'), template = document.querySelector('[data-search-catalog]');
    const catalog = records(template); let active = -1, generation = 0, controller, timer;
    const close = () => { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
    const select = index => {
      const options = [...list.querySelectorAll('[role=option]')];
      if (!options.length) return;
      active = (index + options.length) % options.length;
      options.forEach((el, i) => el.setAttribute('aria-selected', String(i === active)));
      input.setAttribute('aria-activedescendant', options[active].id);
      options[active].scrollIntoView({block:'nearest'});
    };
    const render = (items, query) => {
      list.replaceChildren(); active = -1; input.removeAttribute('aria-activedescendant');
      const matches = items.filter(p => normalize(p.title + ' ' + p.category).includes(query));
      const categories = new Map();
      for (const p of items) {
        if (!normalize(p.category).includes(query)) continue;
        const previous = categories.get(p.categoryUrl);
        if (!previous || Number(p.amount) < Number(previous.amount)) categories.set(p.categoryUrl, p);
      }
      let count = 0;
      const group = (title, rows, category) => {
        if (!rows.length) return;
        const section = document.createElement('li'); section.setAttribute('role', 'group'); section.setAttribute('aria-label', title);
        const heading = document.createElement('div'); heading.className = 'divine-search-heading';
        const label = document.createElement('span'); label.textContent = title;
        const total = document.createElement('span'); total.dataset.noTranslate = ''; total.textContent = ' · ' + rows.length;
        heading.append(label, total); section.append(heading);
        rows.forEach(p => {
          const link = document.createElement('a'); link.className = 'divine-search-row' + (category ? ' divine-search-row--category' : ''); link.href = safeURL(category ? p.categoryUrl : p.url);
          link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false'); link.id = list.id + '-option-' + count++;
          const art = document.createElement('span'); art.className = 'divine-search-art';
          const src = category ? p.categoryImage : p.image;
          if (src && /^(https?:\/\/|\/)/.test(src)) { const img = document.createElement('img'); img.src = src; img.alt = ''; img.width = 104; img.height = 66; art.append(img); }
          const text = document.createElement('span'); text.className = 'divine-search-copy';
          const name = document.createElement('strong'); name.textContent = category ? p.category : p.title; text.append(name);
          if (!category) { const sub = document.createElement('small'); sub.textContent = p.category; text.append(sub); }
          const price = document.createElement('span'); price.className = 'divine-search-price';
          const from = document.createElement('span'); from.textContent = form.dataset.from || 'From';
          const value = document.createElement('span'); value.dataset.noTranslate = ''; value.textContent = p.price;
          if (p.available !== 'false') price.append(from, document.createTextNode(' '));
          price.append(value);
          link.append(art, text, price); section.append(link);
        }); list.append(section);
      };
      group(form.dataset.categories || 'Categories', [...categories.values()], true);
      group(form.dataset.products || 'Products', matches, false);
      if (!count) { const empty = document.createElement('li'); empty.className = 'divine-search-empty'; empty.setAttribute('role','presentation'); empty.textContent = form.dataset.empty || 'No products found'; list.append(empty); }
      list.hidden = false; input.setAttribute('aria-expanded','true');
    };
    const search = () => {
      const query = normalize(input.value), current = ++generation;
      clear.hidden = !query; controller?.abort(); clearTimeout(timer);
      if (!query) return close();
      render(catalog, query);
      // Small catalogs are available immediately. Shopify expands larger catalogs server-side.
      if (Number(template?.dataset.total) <= catalog.length) return;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(form.dataset.predictiveUrl, location.origin);
          url.search = new URLSearchParams({q:input.value, 'resources[type]':'product', 'resources[limit]':'10', section_id:'divine-predictive-search'});
          const response = await fetch(url, {signal:controller.signal}); if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const all = new Map(catalog.map(p => [p.url,p])); records(html.querySelector('template')).forEach(p => all.set(p.url,p));
          if (current === generation && document.activeElement === input) render([...all.values()],query);
        } catch { /* The local catalog and normal Shopify search remain available. */ }
      }, 180);
    };
    input.addEventListener('input',search); input.addEventListener('focus',() => { if(input.value.trim()) search(); });
    clear.addEventListener('click',() => { input.value = ''; search(); input.focus(); });
    input.addEventListener('keydown',event => {
      if (event.key === 'Escape') { ++generation; controller?.abort(); close(); return; }
      if (list.hidden) return;
      if (['ArrowDown','ArrowUp'].includes(event.key)) { event.preventDefault(); select(active + (event.key === 'ArrowDown' ? 1 : -1)); }
      if (event.key === 'Enter' && active >= 0) { event.preventDefault(); list.querySelectorAll('[role=option]')[active]?.click(); }
    });
    form.addEventListener('focusout',() => setTimeout(() => { if (!form.contains(document.activeElement)) close(); },0));
    document.addEventListener('pointerdown',event => { if (!form.contains(event.target)) { ++generation; controller?.abort(); close(); } });
  });
  document.addEventListener('DOMContentLoaded',() => init(document));
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
